// ===== newlogic ui < 2.2.7 =====  //
if (typeof doc === "undefined") {
    var doc = $(document),
        win = $(window),
        html = $("html"),
        body = $("body"),
        lang = html.attr('lang');
}
// ================================= //